<template>
  <article class="change-calculator">
    <v-row class="suggestions">
      <v-col sm="6">
        <v-text-field
          v-model.number="amount"
          width="100%"
          hide-details="auto"
          class="text-field"
          height="107px"
          flat
          solo
        />
      </v-col>
      <v-col sm="6">
        <div class="d-flex align-center">
          <div v-if="!hideIncrementDecrement" class="d-flex flex-column align-start">
            <v-btn
              class="button button-increase-amount"
              height="50px"
              :ripple="false"
              :disabled="disabled"
              @click="increment"
            >
              <font-awesome-icon icon="chevron-up" color="#333333" />
            </v-btn>
            <v-btn
              class="button button-decrease-amount"
              height="50px"
              :ripple="false"
              :disabled="disabled"
              @click="decrement"
            >
              <font-awesome-icon icon="chevron-down" color="#333333" />
            </v-btn>
          </div>
          <v-btn
            height="107px"
            :class="['button', 'button-clear', { 'ml-3': !hideIncrementDecrement }]"
            :ripple="false"
            :disabled="disabled"
            @click="clearAmount"
          >
            <font-awesome-icon icon="times" class="mr-1" color="red" />
            Очистить
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row class="suggestions">
      <v-col v-for="(item, i) in amounts.slice(0, 4)" :key="i" sm="6">
        <v-badge
          class="fullwidth"
          :content="item.count"
          :color="item.count ? '#ff9100' : 'transparent'"
        >
          <v-btn
            class="button"
            :disabled="disabled"
            block
            @click="add(item.amount)"
          >
            {{ item.amount }}₽
          </v-btn>
        </v-badge>
      </v-col>
    </v-row>
    <v-row class="suggestions">
      <v-col v-for="(item, i) in amounts.slice(4, 7)" :key="i" sm="4">
        <v-badge
          class="fullwidth"
          :content="item.count"
          :color="item.count ? '#ff9100' : 'transparent'"
        >
          <v-btn
            class="button"
            :disabled="disabled"
            block
            @click="add(item.amount)"
          >
            {{ item.amount }}₽
          </v-btn>
        </v-badge>
      </v-col>
    </v-row>
  </article>
</template>

<script>
  export default {
    name: 'CashCalculator',
    props: {
      value: {
        type: Number,
        default: 0,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hideIncrementDecrement: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        amounts: [
          { amount: 5000, count: 0 },
          { amount: 2000, count: 0 },
          { amount: 1000, count: 0 },
          { amount: 500, count: 0 },
          { amount: 100, count: 0 },
          { amount: 50, count: 0 },
          { amount: 10, count: 0 },
        ],
      }
    },
    computed: {
      amount: {
        get () { return this.value },
        set (newValue) {
          this.$emit('input', newValue || 0)
        },
      },
    },
    methods: {
      increment () {
        this.amount += 1
      },
      decrement () {
        if (this.amount) {
          this.amount -= 1
        }
      },
      add (amount) {
        if (this.amount) {
          this.amount = parseInt(this.amount)
        }

        this.amount += amount

        const currentAmount = this.amounts.find(item => item.amount === amount)
        if (currentAmount) {
          currentAmount.count++
        }
      },
      clearAmount () {
        this.amount = 0

        this.$nextTick(() => {
          this.amount = 0
          this.clearAmountCount()
        })
      },
      clearAmountCount () {
        this.amounts.forEach(item => {
          item.count = 0
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .change-calculator {
    .suggestions {
      margin-left: -6px;
      margin-right: -6px;
      .col {
        padding: 6px;
      }
    }

    .text-field {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500 !important;
        }
      }

      &.error--text {
        ::v-deep {
          .v-input__slot {
            border: 2px solid @color-error;
          }
        }
      }

      ::v-deep {
        .v-input__slot {
          height: 80px;
          background-color: @color-secondary;
          border-radius: 15px;

          input {
            font-size: 25px;
            line-height: 18px;
          }
        }
      }
    }

    .button {
      height: 80px;
      border-radius: 10px;
      font-size: 16px;
      background-color: @color-secondary !important;

      &.button-increase-amount {
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
      margin-bottom: 7px;
    }

    &.button-decrease-amount {
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
      margin-left: 0 !important;
    }

      &.button-clear {
        display: inline-flex;
        flex-grow: 1;
        font-size: 15px;
      }

      &.button-apply {
        background-color: @color-primary !important;
      }
    }
  }
</style>
